/**
 *
 * VerticalRadioButton (react-hook-form version)
 *
 */

import PropTypes from 'prop-types';

const RadioIcon = ({ checked }) => (
  <div className={checked ? 'vri-out-checked' : 'vri-out'}>
    <div className="vri-wrapper">
      <div className={checked ? 'vri-in-checked' : 'vri-in'} />
    </div>
  </div>
);

const RadioLabel = ({ checked, children }) => (
  <div className={checked ? 'vrl-label-checked' : 'vri-label'}>{children}</div>
);

function VerticalRadioButton({
  value = null,
  onChange,
  options,
  error = null,
}) {
  return (
    <div className="vri-container">
      <div>
        {options.map(option => {
          const isChecked = option.value?.toString() === value?.toString();
          return (
            <div
              className="vrb"
              onClick={() => onChange(option.value)}
              key={`vr-key-${option.value}`}
              role="presentation"
            >
              <RadioIcon checked={isChecked} />
              <RadioLabel checked={isChecked}>{option.label}</RadioLabel>
            </div>
          );
        })}
      </div>
      {error && <div className="vri-error">{error.message}</div>}
    </div>
  );
}

VerticalRadioButton.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  error: PropTypes.object, // from RHF fieldState.error
};

export default VerticalRadioButton;
